import { render, staticRenderFns } from "./customStatistical.vue?vue&type=template&id=b235a9da&"
import script from "./customStatistical.vue?vue&type=script&lang=js&"
export * from "./customStatistical.vue?vue&type=script&lang=js&"
import style0 from "./customStatistical.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports